<form class="formContainer">
  <div *ngFor="let question of validQuestions">
    <!-- QUESTIONS GROUP -->
    <div *ngIf="question.format == 'group'" class="groupContainer questionGroupContainer">
      <app-form [questions]="question.questions" (submit)="submit"></app-form>
    </div>
    <div *ngIf="question.format == 'group'" class="multipleResponseButton2">
      <span *ngIf="question.multiple_response" class="addResponse clickable" (click)="addResponse(question)">+
        Añadir</span>
      <span *ngIf="question.copied" class="removeResponse clickable" (click)="removeResponse(question)">-
        Eliminar</span>
    </div>
    <!-- SINGLE QUESTION -->
    <div *ngIf="question.format != 'group'" class="reverseFlex"
      [ngClass]="!question.show_when || question.show_when.value != '' ? '' : 'displayNone'">
      <span *ngIf="question.format != 'checkbox'" class="labels">{{question.label}} <span
          *ngIf="question.formControl.validator && question.formControl.validator('') && question.formControl.validator('').required">*</span></span>
      <mat-form-field *ngIf="question.format != 'checkbox' && question.format != 'dynamic_select'"
        (keyup.enter)="submitForm()" appearance="none">
        <!--INPUT-->
        <input matInput *ngIf="question.format == 'input'" [type]="question.type"
          (change)="onChangeEvent($event, question)" [(formControl)]="question.formControl"
          [placeholder]="question.placeholder ? question.placeholder : ''">

        <!--SELECT-->
        <mat-select *ngIf="question.format == 'select' || question.format == 'select-multiple'"
          [(formControl)]="question.formControl" [multiple]="question.format == 'select-multiple'"
          (click)="checkOptions(question)" (selectionChange)="reset_show_when(question)">
          <ng-container *ngIf="question.options">
            <mat-option *ngFor="let option of question.options" [value]="option.value">
              {{option.name}}
            </mat-option>
          </ng-container>
          <mat-option *ngIf="!question.options">
            <ion-spinner class="autocompleteLoader"></ion-spinner>
          </mat-option>
        </mat-select>

        <!--DATE-->
        <input matInput *ngIf="question.format == 'date'" [matDatepicker]="picker"
          [(formControl)]="question.formControl">
        <mat-datepicker-toggle *ngIf="question.format == 'date'" matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>

        <!--AUTOCOMPLETE-->
        <input matInput *ngIf="question.format == 'autocomplete'" type="text" [(formControl)]="question.formControl"
          [matAutocomplete]="auto" (input)="searchOptions($event.target.value, question)"
          (click)="searchOptions($event.target.value, question)">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <ng-container *ngIf="!loadingAutocomplete">
            <mat-option [ngClass]="option.value == '0' ? 'noclick':'cickable'"
              *ngFor="let option of question.filtered_options" [value]="option">
              {{option.name}}
            </mat-option>
          </ng-container>
          <mat-option *ngIf="loadingAutocomplete">
            <ion-spinner class="autocompleteLoader"></ion-spinner>
          </mat-option>
        </mat-autocomplete>

        <!-- PICTURE -->
        <div *ngIf="question.format == 'picture' || question.format == 'image-ia'">
          <ngx-mat-file-input class="inputFile" [(ngModel)]="image" [(formControl)]="question.formControl" name="first"
            (change)='previewFile(question)'>
          </ngx-mat-file-input>
          <div class="flexUpload clickable">
            <a class="round">
              <ion-icon color="primary" slot="icon-only" src="/assets/icon/camera-icon.svg">
              </ion-icon>
              <!-- <ion-icon *ngIf="question.src.length != 0" color="primary" slot="icon-only"
                      src="/assets/icon/plus-icon.svg">
                    </ion-icon> -->
            </a>
            <!-- <span class="paddingLeft10" *ngIf="question.src.length == 0">Tomar foto / Seleccionar foto</span> -->
            <span class="paddingLeft10">Añadir foto</span>
          </div>
        </div>

        <!-- FILE -->
        <div *ngIf="question.format == 'file'">
          <ngx-mat-file-input class="inputFile" [formControl]="question.formControl" name="first"
            (change)='previewPDF(question)'>
          </ngx-mat-file-input>
          <div class="flexUpload clickable">
            <a class="round">
              <ion-icon color="primary" slot="icon-only" src="/assets/icon/pdf.svg">
              </ion-icon>
            </a>
            <span class="paddingLeft10">Añadir PDF</span>
          </div>
        </div>

        <!-- CODE -->
        <div *ngIf="question.format == 'code'" (click)="presentCodeModal(question)">
          <div class="flexUpload clickable">
            <a class="round">
              <ion-icon color="primary" slot="icon-only" src="/assets/icon/camera-icon.svg">
              </ion-icon>
            </a>
            <span class="paddingLeft10">Escanear código</span>
          </div>
          <input matInput [(formControl)]="question.formControl" placeholder="Resultado"
            [readonly]="!question.is_editable">
        </div>

        <!--CHECKBOX-->
        <div *ngIf="question.format == 'checkbox'" class="matCheckboxContainer">
          <mat-checkbox [(formControl)]="question.formControl">
            <p style="margin-top: 1rem;" [innerHTML]="question.label"></p>
          </mat-checkbox>
          <mat-error
            *ngIf="question.formControl.touched && !question.formControl.value && question.errorMessage">{{question.errorMessage}}</mat-error>
        </div>

        <!--ERRORS-->
        <mat-error *ngIf="question.formControl?.errors?.required">Campo requerido</mat-error>

        <mat-error
          *ngIf="question.formControl.errors?.customRegex">{{question.formControl.errors.customRegex.msg}}</mat-error>
        <mat-error *ngIf="question.formControl.errors?.pattern">Formato incorrecto</mat-error>
        <mat-error *ngIf="question.formControl.errors?.notObject">Debes escoger un elemento de la lista</mat-error>
        <mat-error *ngIf="question.formControl.errors?.differentPassword">Las contraseñas no coinciden</mat-error>
        <mat-error *ngIf="question.formControl.errors?.passwordTooCommon">Las contraseñas son muy comunes</mat-error>
        <mat-error *ngIf="question.formControl.errors?.maxlength">El número máximo de caracteres es
          {{question.formControl.errors?.maxlength.requiredLength}}</mat-error>
        <mat-error *ngIf="question.formControl.errors?.minlength">El número mínimo de caracteres es
          {{question.formControl.errors?.minlength.requiredLength}}</mat-error>
        <mat-error *ngIf="(question.formControl.errors?.hasOwnProperty('maxContentSize'))">
          El tamaño total no debe superar {{question.formControl.errors?.maxContentSize?.maxSize | byteFormat}}.
          ({{question.formControl.errors?.maxContentSize?.actualSize | byteFormat}}).
        </mat-error>
      </mat-form-field>

      <!-- DYNAMIC SELECT -->
      <div *ngIf="question.format == 'dynamic_select'" class="ion-padding-top">
        <div *ngFor="let level of question.levels; let i = index">
          <mat-form-field appearance="none" class="dynamic-select">
            <mat-label class="dynamic-select-label">{{ level.label }}</mat-label>
            <input matInput placeholder="Buscar..." type="text"
              [formControl]="level.control" 
              (input)="filterDynamicOptions(question, level, i)"
              (click)="filterDynamicOptions(question, level, i)" 
              [matAutocomplete]="auto"/>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let opt of level.filtered_options" (click)="filterDynamicOptions(question, level, i)" [value]="opt.name">{{ opt.name || opt.label }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-error class="mat-error-dynamic-select" *ngIf="level.searchTerm === ''">* Campo requerido</mat-error>
        </div>
      </div>

      <!--CHECKBOX-->
      <div *ngIf="question.format == 'checkbox'" class="matCheckboxContainer">
        <mat-checkbox [(formControl)]="question.formControl">
          <p [innerHTML]="question.label"></p>
        </mat-checkbox>
        <mat-error
          *ngIf="question.formControl.touched && !question.formControl.value && question.errorMessage">{{question.errorMessage}}
        </mat-error>
      </div>

      <!--MULTIPLE RESPONSE BUTTON -->
      <div class="multipleResponseButton">
        <span *ngIf="question.multiple_response" class="addResponse clickable" (click)="addResponse(question)">+
          Añadir</span>
        <span *ngIf="question.copied" class="removeResponse clickable" (click)="removeResponse(question)">-
          Eliminar
        </span>
      </div>

      <!-- IMAGES PREVIEW -->
      <div *ngIf="question.format == 'picture' || question.format == 'image-ia'">
        <div class="imageContainer" *ngFor="let image of question.src">
          <button class="deleteButton" color="primary" ion-button clear small (click)="deleteImg(question, image)">
            <ion-icon color="dark" name="close"></ion-icon>
          </button>
          <img class="billImage" src="{{image}}" />
        </div>
      </div>

      <!-- File PREVIEW -->
      <div *ngIf="question.format == 'file'">
        <div class="imageContainer" *ngFor="let image of question.src">
          <button class="deleteButtonFile" color="primary" ion-button clear small (click)="deleteFile(question, image)">
            <ion-icon color="dark" name="close"></ion-icon>
          </button>
          <!-- <img class="billImage" src="{{image}}" /> -->
          <div class="reverseFlex verticalCenter">
            <ion-icon class="fileIcon" color="primary" slot="icon-only" src="/assets/icon/pdf.svg">
            </ion-icon>
            <!-- <span class="fileName">{{question.formControl.value._fileNames}}</span> -->
          </div>
        </div>
      </div>

    </div>
    <p class="secondaryFontColor"
      *ngIf="(question.type == 'password') && (passwordField?.formControl?.value == validQuestions[0].formControl?.value) && (passwordField?.formControl?.valuelength>0) && validQuestions.length>2">
      La contraseña no puede ser igual al correo
    </p>
    <p class="secondaryFontColor" *ngIf="isFormValid(question)">
      La contraseña no puede estar incluida en el correo
    </p>
    <p class="secondaryFontColor"
      *ngIf="(question.type == 'password') && (configService.hasSequenceInRow(passwordField?.formControl?.value)) && passwordField?.formControl?.value.length > 0 && validQuestions.length > 2">
      La contraseña no puede tener secuencias de letras o números
    </p>
    <p class="secondaryFontColor"
      *ngIf="(question.type == 'password') && (configService.hasRepeatedInRow(passwordField?.formControl?.value)) && passwordField?.formControl?.value.length > 0 && validQuestions.length > 2">
      La contraseña no puede tener caracteres repetidos
    </p>
    <p class="secondaryFontColor"
      *ngIf="(question.type == 'password') && (!configService.containsUppercase(passwordField?.formControl?.value)) && passwordField?.formControl?.value.length > 0 && validQuestions.length > 2">
      La contraseña debe tener al menos una letra mayúscula
    </p>
    <p class="secondaryFontColor"
      *ngIf="(question.type == 'password') && (!configService.containsLowercase(passwordField?.formControl?.value)) && passwordField?.formControl?.value.length > 0 && validQuestions.length > 2">
      La contraseña debe tener al menos una letra minúscula
    </p>
    <p class="secondaryFontColor"
      *ngIf="(question.type == 'password') && (!configService.containsNumber(passwordField?.formControl?.value)) && passwordField?.formControl?.value.length > 0 && validQuestions.length > 2">
      La contraseña debe tener al menos un número
    </p>
  </div>
</form>